import { useTranslation } from "react-i18next";
import { useL } from "@/lib/useL";
import React from "react";
import { Zap } from "lucide-react";
import { useBilling } from "@/contexts/BillingContext";

// Compact widget: credit balance (+ legacy Pro monthly allowance). Tap → buy credits.
export function MonthlyQuotaMeter({ onOpenBooster }) {
  const { billing, credits, unlimitedActive } = useBilling();
  const { t } = useTranslation();
  const L = useL();
  if (!billing || billing.is_anonymous) return null;
  if (billing.is_admin) {
    return (
      <div data-testid="admin-unlimited-badge" className="inline-flex items-center gap-1.5 px-3 py-2 border border-[#002FA7] bg-[#002FA7] text-white font-mono uppercase tracking-[0.14em] text-[11px]">
        <Zap className="w-3 h-3" /> {t("trial.badge_admin")}
      </div>
    );
  }
  if (unlimitedActive) {
    return (
      <div data-testid="unlimited-access-badge" className="inline-flex items-center gap-1.5 px-3 py-2 border border-[#002FA7] text-[#002FA7] font-mono uppercase tracking-[0.14em] text-[11px]">
        <Zap className="w-3 h-3" /> {t("trial.badge_unlimited", { used: billing.unlimited_used, cap: billing.unlimited_cap })}
      </div>
    );
  }
  if (!billing.is_pro && credits === 0) return null;

  const used = billing.monthly_summaries_used || 0;
  const quota = billing.monthly_quota || 20;

  return (
    <button
      type="button"
      onClick={onOpenBooster}
      data-testid="monthly-quota-meter"
      className="inline-flex flex-col items-start gap-1 px-3 py-2 border border-border bg-card hover:bg-[#002FA7]/5 transition-colors text-left"
      data-tip={L("Vos crédits : votre solde restant. Cliquez pour recharger (packs dès 2 €, sans abonnement).", "Your credits: your remaining balance. Click to top up (packs from €2, no subscription).")}
    >
      <div className="flex items-center gap-1.5 font-mono uppercase tracking-[0.14em] text-[10px] text-muted-foreground">
        <Zap className="w-3 h-3" />
        <span>{billing.is_pro ? L("Ce mois · crédits", "This month · credits") : L("Crédits", "Credits")}</span>
      </div>
      <div className="flex items-baseline gap-1.5 font-mono text-[13px] text-foreground">
        {billing.is_pro && (
          <span data-testid="monthly-quota-used">
            <span className="font-semibold">{used}</span>
            <span className="text-muted-foreground">/{quota}</span>
          </span>
        )}
        <span className="text-[#002FA7] font-semibold" data-testid="monthly-quota-bonus">
          {billing.is_pro ? `+${credits}` : credits} {L("crédit", "credit")}{credits > 1 ? "s" : ""}
        </span>
      </div>
    </button>
  );
}

export default MonthlyQuotaMeter;
